(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-nf-reviews]').forEach(root => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const source = root.querySelector('.nf-review-source');
      const track = root.querySelector('.nf-review-track');
      const panel = root.querySelector('.nf-review-panel');
      const previous = root.querySelector('[data-nf-prev]');
      const next = root.querySelector('[data-nf-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const updateArrows = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      const make = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const hydrateImage = async (item, link, productName) => {
        const url = new URL(link, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        try {
          const response = await fetch(url.pathname + '.js', { signal: controller.signal });
          if (!response.ok) return;
          const product = await response.json();
          if (!product.featured_image) return;
          const image = make('img');
          image.width = 110;
          image.height = 140;
          image.alt = productName;
          image.loading = 'lazy';
          image.src = product.featured_image + (product.featured_image.includes('?') ? '&' : '?') + 'width=240';
          image.addEventListener('load', () => item.classList.add('nf-review-has-image'), { once: true });
          image.addEventListener('error', () => image.remove(), { once: true });
          item.prepend(image);
        } catch (_) {
        } finally {
          clearTimeout(timeout);
        }
      };
      const observer = new MutationObserver(() => build());
      let imageObserver;
      let timeout;
      const build = () => {
        const reviews = Array.from(source.querySelectorAll('.jdgm-carousel-item[data-review-id]'));
        if (!reviews.length) return false;
        observer.disconnect();
        clearTimeout(timeout);
        const ids = new Set();
        reviews.forEach(review => {
          if (review.dataset.reviewId === '364d9eec-f4f7-4de1-a5bd-7ec34f64cd74') return;
          if (ids.has(review.dataset.reviewId)) return;
          ids.add(review.dataset.reviewId);
          const item = make('li', 'nf-review-card');
          item.dataset.reviewId = review.dataset.reviewId;
          const content = make('div', 'nf-review-card__content');
          const rating = review.querySelectorAll('.jdgm-stars .jdgm--on').length + review.querySelectorAll('.jdgm-stars .jdgm--half').length / 2;
          const stars = make('div', 'nf-review-stars');
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', rating + ' ' + root.dataset.ratingLabel);
          stars.style.setProperty('--nf-rating', (rating / 5 * 100) + '%');
          [0, 1].forEach(() => { const span = make('span', '', '★★★★★'); span.setAttribute('aria-hidden', 'true'); stars.append(span); });
          content.append(stars);
          const paragraphs = review.querySelectorAll('.jdgm-text p');
          const text = paragraphs.length ? Array.from(paragraphs).map(p => p.textContent.trim()).join('\n\n') : (review.querySelector('.jdgm-text')?.textContent || '').trim();
          if (text.length > 220) {
            const short = text.slice(0, 195).replace(/\s+\S*$/, '') + '…';
            content.append(make('p', 'nf-review-text', short));
            const details = make('details');
            details.append(make('summary', '', root.dataset.readMore), make('p', '', text));
            content.append(details);
          } else content.append(make('p', 'nf-review-text', text));
          content.append(make('p', 'nf-review-author', review.querySelector('.jdgm-reviewer-name')?.textContent.trim() || root.dataset.anonymous));
          const product = review.querySelector('.jdgm-product-name a');
          if (product) {
            const link = make('a', 'nf-review-product', product.textContent.trim());
            link.href = product.href;
            content.append(link);
            item.dataset.productUrl = product.href;
            item.dataset.productName = product.textContent.trim();
          }
          item.append(content);
          track.append(item);
        });
        if (!track.children.length) return false;
        panel.hidden = false;
        source.hidden = true;
        root.classList.add('nf-review-ready');
        previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' }));
        track.addEventListener('scroll', updateArrows, { passive: true });
        new ResizeObserver(updateArrows).observe(track);
        imageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            imageObserver.unobserve(entry.target);
            hydrateImage(entry.target, entry.target.dataset.productUrl, entry.target.dataset.productName);
          });
        }, { root: track, rootMargin: '0px 80px' });
        track.querySelectorAll('[data-product-url]').forEach(item => imageObserver.observe(item));
        updateArrows();
        return true;
      };
      if (!build()) {
        observer.observe(source, { childList: true, subtree: true });
        timeout = setTimeout(() => observer.disconnect(), 45000);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
